// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const mulberryTree = defineModel({
  id: "mulberry-tree",
  batchId: "future",
  name: "Mulberry tree",
  tags: ["scenery","mulberry","tree","low-poly","age-of-mcp","future"],
  summary: "A mulberry. Its leaves feed silkworms, its berries are fruit, its bark makes paper.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.07, 0.1, 0.3, 7), color: "#6e5a40", position: [0, 0.15, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.27, 0), color: "#4f7a3c", position: [0, 0.5, 0], scale: [1.2, 0.9, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.18, 0), color: "#5f8a46", position: [-0.16, 0.6, 0.08], scale: [1.1, 0.85, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#4f7a3c", position: [-0.12, 0.56, -0.12], scale: [1, 0.85, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#3a2440", position: [0.22, 0.46, 0.06] },
      { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#3a2440", position: [-0.18, 0.5, 0.14] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.07, 0.1, 0.3, 7), color: "#6e5a40", position: [0, 0.15, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.27, 0), color: "#4f7a3c", position: [0, 0.5, 0], scale: [1.2, 0.9, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.18, 0), color: "#5f8a46", position: [0.16, 0.6, 0.08], scale: [1.1, 0.85, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#4f7a3c", position: [-0.12, 0.56, -0.12], scale: [1, 0.85, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#3a2440", position: [0.22, 0.46, 0.06] },
      { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#3a2440", position: [-0.18, 0.5, 0.14] },
    ] },
  ],
  animations: [],
});
